import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useAuth } from '../auth/AuthContext';

export function AuthCallback() {
  const [searchParams] = useSearchParams();
  const { completeLogin, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const attempted = useRef(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code || attempted.current) return;
    attempted.current = true;
    completeLogin(code).catch((e) => {
      setError(e instanceof Error ? e.message : 'Sign-in failed.');
    });
  }, [searchParams, completeLogin]);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/home', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="center-page">
      {error ? (
        <>
          <p className="error-text">{error}</p>
          <a href="/" className="btn btn-secondary">Back to start</a>
        </>
      ) : (
        <>
          <div className="spinner" />
          <p className="page-subtitle">Signing you in...</p>
        </>
      )}
    </div>
  );
}
